import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { useEffect } from 'react';

export function ConditionalTravelPayouts() {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    // Only load TravelPayouts if user has given affiliate consent
    if (!hasConsent('affiliate')) {
      return;
    }

    // Skip in development mode
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector('script[data-tp-marker]');
    if (existingScript) {
      return;
    }

    // Create and inject TravelPayouts script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-tp-marker', '1a6e1fd27825b62a976bea977c19fea9');
    script.src = '//c82.travelpayouts.com/content?promo_id=7894&shmarker=520270&type=init&trs=330813';
    
    script.onerror = () => {
      console.warn('Failed to load TravelPayouts script');
    };

    document.body.appendChild(script);

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [hasConsent]);

  return null;
}
